"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styles = require("../CalendarTable/styles");

var _styles2 = require("../../../styles");

var styles = {
  root: {
    extend: _styles.cell,
    fontSize: '14px',
    transition: 'all 0.3s',
    border: "1px solid ".concat(_styles2.colors.gray),
    fontWeight: function fontWeight(_ref) {
      var isCurrentDate = _ref.isCurrentDate;
      return isCurrentDate ? 'bold' : 'normal';
    },
    cursor: function cursor(_ref2) {
      var isEmpty = _ref2.isEmpty,
          isDisabled = _ref2.isDisabled;
      return isEmpty || isDisabled ? 'default' : 'pointer';
    },
    color: function color(_ref3) {
      var isSelected = _ref3.isSelected,
          isInViewMonth = _ref3.isInViewMonth,
          isEmpty = _ref3.isEmpty,
          isDisabled = _ref3.isDisabled;
      if (isSelected || isEmpty) return _styles2.colors.white;
      if (!isInViewMonth || isDisabled) return _styles2.colors.ash;
      return _styles2.colors.black;
    },
    background: function background(_ref4) {
      var isEmpty = _ref4.isEmpty,
          isInRange = _ref4.isInRange,
          isSelected = _ref4.isSelected,
          isDisabled = _ref4.isDisabled;
      if (isEmpty) return _styles2.colors.white;
      if (isSelected) return _styles2.colors.raven;
      if (isInRange) return _styles2.colors.stone;
      if (isDisabled) return _styles2.colors.grey;
      return _styles2.colors.white;
    },
    opacity: function opacity(_ref5) {
      var isDisabled = _ref5.isDisabled;
      return isDisabled ? 0.5 : 1;
    },
    '&:hover': {
      background: function background(_ref6) {
        var isSelected = _ref6.isSelected,
            isInRange = _ref6.isInRange,
            isEmpty = _ref6.isEmpty,
            isDisabled = _ref6.isDisabled;
        if (isEmpty || isDisabled) return '';
        if (isSelected) return _styles2.colors.charcoal;
        if (isInRange) return _styles2.colors.stone;
        return _styles2.colors.stone;
      }
    }
  }
};
var _default = styles;
exports["default"] = _default;